
import {SETSECRET} from "../actions/Types"
const INTIAL_STATE=
{
    secret:null,
}
export default (state=INTIAL_STATE,action)=>{

    switch (action.type) {
        case SETSECRET:
            return {...INTIAL_STATE,secret:action.secret}
        default:
            return state;
    }
}